import React, { createContext, useEffect, useState, useRef, useMemo } from "react";
import api from "../Api";

export const GlobalMenuContext = createContext();

export function GlobalMenuProvider({ children }) {
  const [menus, setMenus] = useState([]);
  const [loading, setLoading] = useState(true);
  const abortControllerRef = useRef(null);

  const loginTime = parseInt(localStorage.getItem("loginTime") || "0");

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setMenus([]);
      setLoading(false);
      return;
    }

    setLoading(true);

    abortControllerRef.current?.abort();
    abortControllerRef.current = new AbortController();

    const user = JSON.parse(localStorage.getItem("userProfile") || "{}");

    const cacheKey = `menus_user_${user.id}`;

    const cached = localStorage.getItem(cacheKey);
    if (cached) {
      setMenus(JSON.parse(cached));
      setLoading(false);
      return;
    }

    api
      .get("/menus", { signal: abortControllerRef.current.signal })
      .then(({ data }) => {
        setMenus(data);
        localStorage.setItem(cacheKey, JSON.stringify(data));
        setLoading(false);
      })
      .catch((err) => {
        if (err.name !== "AbortError") {
          console.error(
            "❌ Menus failed:",
            err.response?.status || err.message,
          );
          setMenus([]);
        }
        setLoading(false);
      });

    return () => abortControllerRef.current?.abort();
  }, [loginTime]);

  const value = React.useMemo(() => ({ menus, loading }), [menus, loading]);
  
  return (
    <GlobalMenuContext.Provider value={value}>
      {children}
    </GlobalMenuContext.Provider>
  );
}
